import { Link } from 'react-router';

import styles from './style.module.css';

// A link that leads to a page where something is done, such as Invite
// patient, drawn as the accent button with a plus, as the blueprint draws it
// beside a page's title.
export function ActionLink({ to, children }) {
  return (
    <Link className={ styles.link } to={ to }>
      <span className={ styles.plus } aria-hidden='true'></span>

      { children }
    </Link>
  );
}
